<!--
 * @Author: 田鑫
 * @Date: 2022-01-07 14:39:23
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-07 15:01:30
 * @Description: 年夜饭时段管理
-->

<template>
  <div>
    <hx-calendar></hx-calendar>
  </div>
</template>

<script>
import hxCalendar from "./calendar";
export default {
  data() {
    return {};
  },
  components: { hxCalendar },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //生命周期 - 方法
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>